import React from "react";

const SvgIcnDelete = props => (
  <svg
    id="icn_delete_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>{".icn_delete_svg__cls-1{fill:#4a4b4c}"}</style>
    </defs>
    <path className="icn_delete_svg__cls-1" d="M7 9h10v12H7zM5 5h14v3H5z" />
    <path className="icn_delete_svg__cls-1" d="M9 3h6v3H9z" />
  </svg>
);

export default SvgIcnDelete;
